import { DsFormTemplateFieldType } from '../../types/ds-form-template-field.type';
import { DsFormsExcelSheetError } from './ds-forms-excel-sheet-error.class';
import { DsFormsExcelSheetImportDataInterface } from '../../interfaces/forms-excel/ds-forms-excel-sheet-import-data.interface';
import { dsFormsGetTemplateField } from '../../functions/ds-forms-get-template-field.function';

/**
 * Class containing the list of fields to import, and potentially some errors if the worksheet was not correctly filled.
 */
export class DsFormsExcelSheetImportData {
  /**
   * List of fields found inside the excel worksheet
   */
  result: DsFormTemplateFieldType[];

  /**
   * List of errors found while parsing the selected worksheet
   */
  errors: DsFormsExcelSheetError[];

  /**
   * Creates an instance of DsFormsExcelSheetImportData.
   *
   * @param json JSON data
   */
  constructor(json: DsFormsExcelSheetImportDataInterface) {
    this.result = json.result ? json.result.map((field) => dsFormsGetTemplateField(field) || field) : [];
    this.errors = json.errors ? json.errors.map((error) => new DsFormsExcelSheetError(error)) : [];
  }
}
